import React from 'react';
import { Form } from '../../hoc/context/product/context-model';
import Enrollment from './patient/enrollment';

interface FormProps {
	form: Form,
	next: Function
};

const FormFactory: React.FC<FormProps> = ({ form, next }) => {
	return (
		<>
			{form.id === 'patientDetails' && (
				<Enrollment nextForm={next as () => void} />
			)}
		</>
	);
};

export default FormFactory;
